import { BorderConfiguration } from "../../http/border/types/configurations";
import { HrailConfiguration } from "../../http/hrail/types/configurations";
import { PatrolConfiguration } from "../../http/patrol/types/configurations";
import { Configuration } from "../../http/types/configurations";
import { VertigripConfiguration } from "../../http/vertigrip/types/configurations";

export const isVertigrip = (data?: Configuration): data is VertigripConfiguration => {
  return data?.system?.id === "vertigrip";
};

export const isBorder = (data?: Configuration): data is BorderConfiguration => {
  return data?.system?.id === "border";
};

export const isPatrol = (data?: Configuration): data is PatrolConfiguration => {
  return data?.system?.id === "patrol";
};

export const isHRail = (data?: Configuration): data is HrailConfiguration => {
  return data?.system?.id === "h-rail";
};

// export const isSafetyNet = (data?: Configuration): data is SafetyNetConfiguration => {
//   return data?.system?.id === "safety-net";
// };

// export const isLadstep = (data?: Configuration): data is LadstepConfiguration => {
//   return data?.system?.id === "ladstep";
// };

// export const isOverpass = (data?: Configuration): data is OverpassConfiguration => {
//   return data?.system?.id === "overpass";
// };
